var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoadSurfaceAndStructure = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.2647 2.11034H0.735275C0.328983 2.11034 0 1.63823 0 1.05517C0 0.472113 0.328983 0 0.735275 0H15.2647C15.671 0 16 0.472113 16 1.05517C16 1.63823 15.671 2.11034 15.2647 2.11034Z",
  fill: "#1D1D1B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3682 3.33333H0.631845C0.283067 3.33333 0 3.67455 0 4.09498V13.2383C0 13.6588 0.283067 14 0.631845 14H15.3682C15.7169 14 16 13.6588 16 13.2383V4.09498C16 3.67455 15.7169 3.33333 15.3682 3.33333ZM6.92249 12.4767L10.7313 4.85664H13.5063L9.69756 12.4767H6.92249ZM2.35973 12.4767L6.16849 4.85664H9.01011L5.20135 12.4767H2.35973ZM4.44735 4.85664L1.26369 11.2251V4.85664H4.44735ZM11.4187 12.4767L14.7363 5.83916V12.4767H11.4187Z",
  fill: "#1D1D1B"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoadSurfaceAndStructure);
export { ForwardRef as ReactComponent };